import React, {useEffect, useState} from 'react';
import styles from './index.module.css';
import {Link} from 'react-router-dom';
import {RiArrowLeftSLine} from 'react-icons/ri';
import {MdOutlineMailOutline} from 'react-icons/md';
import {useDispatch, useSelector} from 'react-redux';
import { useEscapeKey } from '../../../hooks';
import NewChat from './NewChat';
import Content from './Content';
import {chats as getChats} from '../../../actions/lk';

const Index = () => {

    const dispatch = useDispatch();
    const chats = useSelector((state) => state.lk.chats);

    const [newChat,
        setNewChat] = useState(null);

    const [timer,
        setTimer] = useState(0);

    const handleNewChat = () => {
        setNewChat({
            tomid: null, 
            title: '', 
            message: '', 
            type: 'constant', 
            mid: null, 
            value: 'Выберите пользователя'});
    };

    useEscapeKey(() => setNewChat(null)); // Закроется по ESC

    useEffect(() => {
        dispatch(getChats());
        setTimeout(() => {
            setTimer(timer + 1);
        }, 60000);

    }, [timer]);

    return (
        <div className={styles.wrapper}>
            <Link to="/lk" className={styles.back}>
                <RiArrowLeftSLine/>
                Назад
            </Link>

            <div className={styles.header}>
                <div className={styles.title}>Ваши диалоги</div>
                <div className={styles.newChat} onClick={handleNewChat}>
                    <MdOutlineMailOutline/>
                    Начать новый диалог
                </div>
            </div>

            {newChat && <NewChat newChat={newChat} setNewChat={setNewChat}/>}

            <div className={styles.content}>
                {chats
                    ?.length === 0
                        ? (
                            <div className={styles.empty}>
                                Вы пока ни с кем не переписывались. Начните новый диалог.
                            </div>
                        )
                        : <Content chats={chats}/>
}

            </div>
        </div>
    );
};

export default Index;
